import React from 'react';
import pluxeeLogoDarkBlue from '../../themes/_shared/images/Pluxee_Logo_DarkBlue_RGB.png';
import pluxeeLogoWhite from '../../themes/_shared/images/Pluxee_Logo_White_RGB.png';
import { SwLink } from '../link/SwLink';

export const PLUXEE_WEBSITE_URL = 'https://www.pluxee.be';

export enum PluxeeLogoVariant {
  DARK_BLUE = 'darkBlue',
  WHITE = 'white',
}

const PLUXEE_LOGOS: Record<PluxeeLogoVariant, string> = {
  [PluxeeLogoVariant.DARK_BLUE]: pluxeeLogoDarkBlue,
  [PluxeeLogoVariant.WHITE]: pluxeeLogoWhite,
};

type PluxeeLogoLinkProps = {
  variant?: PluxeeLogoVariant;
  className?: string;
  imageClassName?: string;
};

export const PluxeeLogoLink = ({
  variant = PluxeeLogoVariant.DARK_BLUE,
  className,
  imageClassName,
}: PluxeeLogoLinkProps) => (
  <SwLink
    to={PLUXEE_WEBSITE_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
  >
    <img src={PLUXEE_LOGOS[variant]} alt="Pluxee" className={imageClassName} />
  </SwLink>
);
